import React from "react";
import { globalEffectsCounterMap, globalEffectsTeardownMap } from "../globals.js";
/**
 * Hook that runs an effect once globally even if mounted multiple times
 * by multiple components.
 *
 * Requires that the `globalEffect` variable be a stable reference.
 */
export const useGlobalEffect = globalEffect => {
  React.useEffect(() => {
    const incrementedCount = (globalEffectsCounterMap.get(globalEffect) || 0) + 1;
    globalEffectsCounterMap.set(globalEffect, incrementedCount);
    if (incrementedCount === 1) {
      const teardown = globalEffect();
      globalEffectsTeardownMap.set(globalEffect, teardown);
    }
    return () => {
      const decrementedCount = globalEffectsCounterMap.get(globalEffect) - 1;
      globalEffectsCounterMap.set(globalEffect, decrementedCount);
      if (decrementedCount === 0) {
        const teardown = globalEffectsTeardownMap.get(globalEffect);
        globalEffectsCounterMap.delete(globalEffect);
        globalEffectsTeardownMap.delete(globalEffect);
        if (teardown) {
          teardown();
        }
      }
    };
  }, []);
};